'use client';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl'
import { FeaturesListType } from '@/types/ui';
import { Phone, Thunder, Shield, People } from '@/public/images/icons/icons';
import { fadeInUp, viewportOnce } from '@/lib/animations';


export default function WhyKuik() {
    const t = useTranslations('WhyKUIK');

    const features: FeaturesListType[] = [
        {
            title: 'reason_1_title',
            description: "reason_1_desc",
            icon: <Phone width={30} height={30} className="shrink-0" />,
        },
        {
            title: 'reason_2_title',
            description: "reason_2_desc",
            icon: <Thunder width={30} height={30} className="shrink-0 thunder-strike" />,
        },
        {
            title: 'reason_3_title',
            description: "reason_3_desc",
            icon: <Shield width={30} height={30} className="shrink-0 shield-flip" />,
        },
        {
            title: 'reason_4_title',
            description: "reason_4_desc",
            icon: <People width={30} height={30} className="shrink-0" />,
        },
    ];

    return (
        <motion.section
            className="w-full bg-light py-12 sm:py-20 px-6 sm:px-10 lg:px-16"
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            variants={fadeInUp}
        >
            <div className="max-w-8xl mx-auto">
                <div className="text-center max-w-2xl mx-auto mb-14 sm:mb-20">
                    <span className="text-xs sm:text-sm font-semibold tracking-widest color-primary uppercase">
                        {t('why_kuik')}
                    </span>
                    <h2 className="text-3xl sm:text-4xl font-semibold text-black tracking-tight mt-3 leading-tight">
                        {t.rich('title', {
                            highlight: (chunks) => <span className="color-primary">{chunks}</span>,
                            br: () => <br />,
                        })}
                    </h2>
                </div>
                <div className="grid grid-cols-1 max-w-7xl mx-auto sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-6">
                    {features.map((feature: FeaturesListType, index: number) => (
                        <div key={feature.title} className="grid grid-rows-[auto_auto_1fr] items-start">
                            {feature.icon && (
                                <div className={`mb-3${index === 2 ? ' shield-flip-wrap' : ''}`}>
                                    {feature.icon}
                                </div>
                            )}
                            <h3 className="text-lg font-bold text-black tracking-tight mb-2 min-h-[3rem]">
                                {t(feature.title)}
                            </h3>
                            <p className="text-sm text-gray-600 leading-relaxed font-normal">
                                {t(feature.description)}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </motion.section>
    );
}